import { Grid, makeStyles, Typography } from '@material-ui/core'
import { FC, useState, useEffect, useRef } from 'react'
import UploadImage from '../../../control/uploadImage/uploadImage'
import useTranslate from '../../../i18n/useTranslate'
import useAuthenStore from '../../../stores/authen/authenStore'
import usePreferenceProfile from '../../../services/um/usePreferenceProfile'
import Dialog, { DialogType } from '../../../control/dialog/dialog'
import { convertPathToNameImg } from '../../../utilities/pathImg'

export type LanguageType = 'th' | 'en'

interface UploadLogoProps {
    initialValue?: any
    form: any
}
const UploadLogo: FC<UploadLogoProps> = ({ initialValue, form }) => {
    const translate = useTranslate()
    const classes = usestyles()
    const authenStore = useAuthenStore()
    const { postImageLogo } = usePreferenceProfile()
    const [temp, setTemp] = useState<{
        imgUpload_th: string | null
        imgUpload_en: string | null
        name_th: string | null
        name_en: string | null
    }>({
        imgUpload_th: null,
        imgUpload_en: null,
        name_th: null,
        name_en: null,
    })

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    useEffect(() => {
        setTemp({
            imgUpload_th: initialValue?.signatureTH || null,
            imgUpload_en: initialValue?.signatureEN || null,
            name_th: convertPathToNameImg(initialValue?.signatureTH) || null,
            name_en: convertPathToNameImg(initialValue?.signatureEN) || null,
        })
    }, [initialValue])

    const onUpload = async (event: React.ChangeEvent<HTMLInputElement>, language: LanguageType) => {
        const file = event.target.files?.[0]

        if (file) {
            setConfigDialog({
                title: `${translate.get('UM.UPLOAD.MESSAGE.HEADER')}`,
                content: `${translate.get('UM.UPLOAD.MESSAGE.CONFIRM')}`,
                type: 'alert-confirm',
                onClickConfirm: () => onSave(event, language),
            })

            dialogTwoRef.current?.openDialog()
        }
    }

    const onSave = async (event: React.ChangeEvent<HTMLInputElement>, language: LanguageType) => {
        const file = event.target.files?.[0]

        const formDataImage = new FormData()
        if (file) {
            formDataImage.append('userID', String(authenStore.profile.userId))
            formDataImage.append('language', language)
            formDataImage.append('files', file)

            const { result } = await postImageLogo(formDataImage)

            if (result.length > 0) {
                if (language === 'th') {
                    setTemp({ ...temp, imgUpload_th: result[0].path, name_th: result[0].filename })
                    form.change('imgUpload_th', result)
                } else {
                    setTemp({ ...temp, imgUpload_en: result[0].path, name_en: result[0].filename })
                    form.change('imgUpload_en', result)
                }
                setConfigDialog({
                    title: `${translate.get('UM.UPLOAD.MESSAGE.HEADER')}`,
                    content: `${translate.get('UM.UPLOAD.MESSAGE.SUCCESS')}`,
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            } else {
                setConfigDialog({
                    title: `${translate.get('UM.UPLOAD.MESSAGE.HEADER')}`,
                    content: `${translate.get('UM.UPLOAD.MESSAGE.ERROR')}`,
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            }
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    return (
        <Grid container justify="center" spacing={2} className={classes.container}>
            <Grid item xs={12} md={6} lg={6}>
                <Typography>{translate.get('UM.UPLOAD.SIGNATURE_TH')}</Typography>
                <img
                    src={
                        temp.imgUpload_th
                            ? `${process.env.REACT_APP_UPLOAD}${temp.imgUpload_th}`
                            : `${process.env.PUBLIC_URL}/img/default.jpg`
                    }
                    id="profile"
                    alt=""
                    width="300"
                    height="230"
                    className={classes.image}
                />
                <Grid container alignItems="center" direction="row">
                    <Grid item xs={6} md={6} lg={6} style={{ textAlign: 'center' }}>
                        <Typography>{temp.name_th ? temp.name_th : ''}</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} style={{ textAlign: 'end' }}>
                        <UploadImage
                            name="imgUpload_th"
                            onChange={(event) => onUpload(event, 'th')}
                            color={'primary'}
                            labelTitle={translate.get('BUTTON.UPLOAD')}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Typography>{translate.get('UM.UPLOAD.SIGNATURE_EN')}</Typography>
                <img
                    src={
                        temp.imgUpload_en
                            ? `${process.env.REACT_APP_UPLOAD}${temp.imgUpload_en}`
                            : `${process.env.PUBLIC_URL}/img/default.jpg`
                    }
                    id="profile"
                    alt=""
                    width="300"
                    height="230"
                    className={classes.image}
                />
                <Grid container alignItems="center" direction="row">
                    <Grid item xs={6} md={6} lg={6} style={{ textAlign: 'center' }}>
                        <Typography>{temp.name_en ? temp.name_en : ''}</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} style={{ textAlign: 'end' }}>
                        <UploadImage
                            name="imgUpload_en"
                            onChange={(event) => onUpload(event, 'en')}
                            color={'primary'}
                            labelTitle={translate.get('BUTTON.UPLOAD')}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Grid>
    )
}
export default UploadLogo

const usestyles = makeStyles((theme) => ({
    image: {
        display: 'flex',
        margin: '15px auto',
        objectFit: 'contain',
    },
    container: {
        padding: '8px 15px',
    },
}))
